import { render, staticRenderFns } from "./serviceContentList.vue?vue&type=template&id=587ac020&scoped=true&"
import script from "./serviceContentList.vue?vue&type=script&lang=js&"
export * from "./serviceContentList.vue?vue&type=script&lang=js&"
import style0 from "./serviceContentList.vue?vue&type=style&index=0&id=587ac020&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ac020",
  null
  
)

export default component.exports